import * as React from "react";

import { ILeanSvgIconWithColor } from "../ILeanSvgIconWithColor";

export const circle_information_small: React.FunctionComponent<ILeanSvgIconWithColor> = ({ iconColor, ...rest }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...rest}>
      <path
        fill="none"
        stroke={iconColor}
        d="M20.5,12.0002 C20.5,16.7462 16.746,20.5002 12,20.5002 C7.254,20.5002
        3.5,16.7462 3.5,12.0002 C3.5,7.2532 7.254,3.5002 12,3.5002 C16.746,3.5002
        20.5,7.2532 20.5,12.0002 Z M12.48,7.9997 L12.48,5.9997 M14.9805,16.49
        L9.9805,16.49 M12.48,16.49 L12.48,10.49 L10,10.49"
      />
    </svg>
  );
};
